import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { FFFErrorBoundary } from '@fff-web/fff-ui-shared';
import './App.css';
import AboutUs from './pages/AboutUs';
import Careers from './pages/Careers';
import DownloadApp from './pages/DownloadApp';
import Inquiries from './pages/Inquiries';
import JobPost from './pages/JobPost';
import NotFoundError from './pages/NotFoundError';
import Dashboard from './pages/Referrals/Dashboard';
import Invite from './pages/Referrals/Invite';

function App() {
  return (
    <HelmetProvider>
      <FFFErrorBoundary>
        <div className="App">
          <Router>
            <Routes>
              <Route path="/inquiries" element={<Inquiries />} />
              <Route path="/s/inquiries" element={<Inquiries />} />
              <Route path="/invite" element={<Invite />} />
              <Route path="/s/invite" element={<Invite />} />
              <Route path="/my-account/referral-dashboard" element={<Dashboard />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/s/about-us" element={<AboutUs />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/job-post" element={<JobPost />} />
              <Route path="/mobile-app" element={<DownloadApp />} />
              <Route path="/s/mobile-app" element={<DownloadApp />} />
              <Route path="*" element={<NotFoundError />} />
            </Routes>
          </Router>
        </div>
      </FFFErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
